import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchReportDetails } from "../actions/reportDetailsAction";
import PowerBIEmbedComponent from "./powerbi/PowerBIEmbedComponent";
import { RootState } from "../store/store";
import { isEmptyObject } from "jquery";
import { useHistory, useParams } from "react-router-dom";
import { Resource, resourceTypeEnum } from "../types/resourceType";
import Loading from "../pages/Loading";
import { resourceSelectedByUser } from "../actions/resourcesAction";

const ReportContainer = () => {
  const { id } = useParams<{ id?: string }>();
  const resourcesState = useSelector((state: RootState) => state.resources);
  const reportState = useSelector((state: RootState) => state.report);
  const dispatch = useDispatch();
  let history = useHistory();

  useEffect(() => {
    //loads the first report on the list by default.
    if (
      isEmptyObject(id) &&
      !isEmptyObject(resourcesState.resources.data) &&
      isEmptyObject(reportState.report)
    ) {
      const report = resourcesState.resources.data.find(
        (item: Resource) =>
          item.type === resourceTypeEnum.REPORT &&
          item.uris[0] !== "/*" &&
          item.uris[0] !== "/api/resources/"
      );
      history.push(`/reports/${report.id}`);
      dispatch(
        resourceSelectedByUser(report?.id, report?.displayName, report?.type)
      );
    }
  }, [
    dispatch,
    resourcesState.resources.data,
    id,
    history,
    reportState.report,
  ]);

  useEffect(() => {
    //loads the report selected by the user.
    if (!isEmptyObject(id) && reportState.report?.resourceId !== id) {
      dispatch(fetchReportDetails(id));
    }
  }, [dispatch, reportState.report?.resourceId, id]);

  useEffect(() => {
    if (!isEmptyObject(reportState.report?.id)) {
      const report = resourcesState.resources.data.find(
        (item: Resource) => item.id === id
      );
      dispatch(
        resourceSelectedByUser(report?.id, report?.displayName, report?.type)
      );
    }
  }, [dispatch, id, reportState.report?.id, resourcesState.resources.data]);
  /*
  
  */

  return !reportState.loading ? <PowerBIEmbedComponent /> : <Loading />;
};

export default ReportContainer;
